// extracted by mini-css-extract-plugin
export var boxItems = "_67-1";
export var boxItemsLg = "_67-2";
export var button = "_67-7";
export var buttonLg = "_67-8";
export var filterGroupBox = "_67-0";
export var icon = "_67-3";
export var iconSecondary = "_67-6";
export var iconWrapper = "_67-4";
export var iconWrapperLg = "_67-5";